module.exports = __webpack_public_path__ + "static/media/hans-s.2ece7b34.mp3";